import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LogoutComponent} from './shared/login/logout.component';
import { VerifyEmailComponent} from './shared/login/verify_emailtoken.component';
// import { PasswordResetComponent } from './shared/login/passwordreset.component';
import { ParentAccountRegistrationComponent} from './shared/parent_account_registration/components/parent_account_registration.component'
import { TemporaryAdmissionComponent } from './shared/parent_account_registration/components/temporary_regform.component';
import { TemporaryClassNPhotoComponent } from './shared/parent_account_registration/components/temp_regform_class_nPhoto.component';
import { TensParentRegistrationComponent} from './shared/parent_account_registration/components/tens_parent_registration.component'
import { AuthGuard } from './shared/guards/auth.guard';
import { RouterTestingModule } from '@angular/router/testing';
import { HttpClientTestingModule } from '@angular/common/http/testing';
import { slugviewComponent} from './shared/login/slugpages/slugpages_view.component'
import { RegistrationStatusComponent } from './shared/parent_account_registration/components/registration_status.component';
import {OnlineApplicationHomeComponent} from './shared/online_admission_form_components/online_application_home_components/online_application_home.component';
import {OnlineApplicationFormComponent} from './shared/online_admission_form_components/online_application_form_components/online_application_form.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./modules/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard] },
  { path: 'login', loadChildren: () => import('./shared/login/login.module').then(m => m.LoginModule) },
  { path: 'logout', component: LogoutComponent },
  { path: 'verifyemail', component: VerifyEmailComponent },
  { path: 'slugpages/:id',component: slugviewComponent},
  { path: 'school_application_form',component: OnlineApplicationHomeComponent},
  { path: 'school_application_form/apply',component: OnlineApplicationFormComponent},
  // { path: 'passwordreset', component: PasswordResetComponent },
  { path: 'errors', loadChildren: () => import('./shared/errorpages/errorpages.module').then(m => m.ErrorPagesModule)},
  { path: '**', redirectTo: 'errors' },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }    
